import { Redirect, Route, useLocation } from 'react-router-dom';
import Logger from '../lib/Logger';
import { getParsedTrialId, isValidTrialId, TRIAL_ID } from '../trial/trialUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const LOG = Logger.getLogger('TrialRoute');
const TrialRoute = props => {
  const {
    hash,
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const trialId = getParsedTrialId();
  if (!trialId || !isValidTrialId(trialId)) {
    LOG.error('Invalid trial URL with missing or invalid trialId.', {
      extra: {
        currentUrl: window.location.toString(),
        documentReferrer: document.referrer
      }
    });
    searchParams.delete(TRIAL_ID);
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/`,
        search: searchParams.toString(),
        hash
      }
    });
  }
  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};
export default TrialRoute;